import React from 'react'
import { DatePicker, Form } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import { DatePickerQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'

const Container = styled.div`
  margin: 12px 0;
`

function DatePickerQuestion({
  field,
  formFieldName,
  layout,
  disabled = false,
  required = false,
  customRules = [],
  placeholder,
  format = 'YYYY-MM-DD',
  showTime = false,
  picker = 'date',
  allowClear = false
}: DatePickerQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = field?.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <DatePicker
              disabled={disabled}
              placeholder={placeholder}
              format={format}
              showTime={showTime}
              picker={picker}
              style={{ width: '100%' }}
              allowClear={allowClear}
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default DatePickerQuestion
